module.exports = __webpack_public_path__ + "img/nav_b2_pic2.7d0aac4d.png";